import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, NgModel } from '@angular/forms';
import { isDefined } from 'src/app/components/utils/utils';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DataTypeComponent } from '../../../data-type-component';

@Component({
  selector: 'app-form-field-multi-option',
  templateUrl: './multi-option-form-field.component.html',
  standalone: false,
})
export class MultiOptionFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: any;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  extractedData: string[];

  matcher = new MyErrorStateMatcher();

  private validatorsSet = false;

  ngOnDestroy() {}

  ngOnInit(): void {
    this.setExtractedData();
    this.onModelChange();
  }

  private setExtractedData() {
    if (isDefined(this.formGroup)) {
      this.extractedData = this.extractData(this.data);
    } else {
      this.extractedData = this.data;
    }
  }

  private extractData(data) {
    if (this.fieldConfig && this.fieldConfig.propertyName === undefined) {
      const formControl = this.formGroup.get(this.fieldConfig.name);
      if (this.formGroup && formControl && formControl.value) {
        return formControl.value;
      }
      return data || [];
    }

    return data ? data[Object.keys(data)[0]] : undefined;
  }

  onModelChange(): void {
    if (this.formGroup) {
      if (this.fieldConfig.propertyName && this.fieldConfig.propertyName.length > 0) {
        let dataToUpdate = this.formGroup.get(this.fieldConfig.name).value;
        if (!dataToUpdate) {
          dataToUpdate = {};
          dataToUpdate[this.fieldConfig.name] = [];
        }

        dataToUpdate[this.fieldConfig.propertyName] = this.extractedData;
        this.formGroup.get(this.fieldConfig.name).setValue(dataToUpdate);
      } else {
        this.formGroup.get(this.fieldConfig.name).setValue(this.extractedData);
      }
    }
  }

  condition(v: UiValidator, ngModel: NgModel) {
    if (!this.validatorsSet) {
      this.validatorsSet = true;
      ngModel.control.setValidators(MyErrorStateMatcher.convertToAngularValidators([this.fieldConfig]));
    }

    return this.getValidatorConfig(v).condition(ngModel.control);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  ngOnChanges(changes: SimpleChanges): void {}
}
